var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            title: "关联客户 ",
            "mask-closable": false,
            closable: false
          },
          model: {
            value: _vm.relevanceShow,
            callback: function($$v) {
              _vm.relevanceShow = $$v
            },
            expression: "relevanceShow"
          }
        },
        [
          _c(
            "Form",
            {
              ref: "formValidate",
              attrs: {
                model: _vm.formValidate,
                rules: _vm.ruleValidate,
                "label-width": 100
              }
            },
            [
              _c(
                "FormItem",
                { attrs: { label: "客户手机号", prop: "phone" } },
                [
                  _c("AutoComplete", {
                    attrs: {
                      data: _vm.AutoCompleteData,
                      placeholder: "请输入客户手机号"
                    },
                    on: {
                      "on-search": _vm.handlechange,
                      "on-select": _vm.handleSelect
                    },
                    model: {
                      value: _vm.formValidate.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.formValidate, "phone", $$v)
                      },
                      expression: "formValidate.phone"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "关联客户说明", prop: "desc" } },
                [
                  _c("Input", {
                    attrs: {
                      type: "textarea",
                      maxlength: 500,
                      autosize: { minRows: 2, maxRows: 5 },
                      placeholder: "500字内"
                    },
                    model: {
                      value: _vm.formValidate.desc,
                      callback: function($$v) {
                        _vm.$set(_vm.formValidate, "desc", $$v)
                      },
                      expression: "formValidate.desc"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { type: "text", size: "large" },
                  on: { click: _vm.handleCancel }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: { type: "primary", size: "large" },
                  on: {
                    click: function($event) {
                      return _vm.handleSubmit("formValidate")
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-419cac1b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-419cac1b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/commonTmp/CRM/CRM_relevance.vue
// module id = null
// module chunks = 